import { infuse } from '../ioc-config';

export const useCanonicalLink = () => {
  const { aemApp } = infuse('config');

  const setCanonicalLinkForSrp = (modelFilter: string) => {
    if (aemApp?.isPublished) {
      try {
        let srpUrl: URL;

        if (modelFilter) {
          srpUrl = new URL(aemApp.srpUrl.replace(/\/$/, ''));
          srpUrl.searchParams.set('emhmodel', modelFilter);
        } else {
          srpUrl = new URL(aemApp.srpUrl);
        }

        setCanonicalLink(srpUrl);
      } catch (e) {
        return;
      }
    }
  };

  const setCanonicalLinkForPdp = (code: string) => {
    if (aemApp?.isPublished) {
      try {
        const pdpUrl = new URL(`${aemApp.pdpUrl.replace(/\/$/, '')}/${code}`);

        setCanonicalLink(pdpUrl);
      } catch (e) {
        return;
      }
    }
  };

  const setCanonicalLink = (href: URL) => {
    if (!href) return;

    // Remove existing canonical link(s)
    document.head.querySelectorAll('link[rel="canonical"]').forEach((element) => element.remove());

    const link = document.createElement('link');

    link.rel = 'canonical';
    link.href = href.toString();

    document.head.append(link);
  };

  return {
    setCanonicalLinkForSrp,
    setCanonicalLinkForPdp,
  };
};
